export default "__VITE_ASSET__fede7750__"